// Auto-generated file - do not edit manually
export const LOCALE_HASH = 'eb05f4fb';
